import {Box, Paper, useMediaQuery, useTheme} from '@mui/material';
import tiledBackground from '../../assets/tiledBackground.svg';
import {PropsWithChildren, useEffect} from 'react';
import {useIntercom} from 'react-use-intercom';

type Props = {
  savingStep?: boolean;
  background?: string;
};

export const ReferencingLayout = ({
  children,
  savingStep,
  background = tiledBackground,
}: PropsWithChildren<Props>) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const {update} = useIntercom();

  useEffect(() => {
    update({hideDefaultLauncher: fullScreen});
  }, [update, fullScreen]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{
        height: '100vh',
        width: '100vw',
        backgroundImage: `url(${background})`,
        backgroundSize: '250px',
      }}
      data-saving-step={`${savingStep}`}
    >
      <Paper
        elevation={fullScreen ? 0 : 1}
        sx={{
          width: {xs: '100%', sm: 560},
          minHeight: {xs: '100vh', sm: 200},
          borderRadius: {xs: 0, sm: 1},
          overflow: 'auto',
        }}
      >
        {children}
      </Paper>
    </Box>
  );
};
